// extracted by css-extract-rspack-plugin
var _1 = "z4_iPqCAIbQzedZE";
var _2 = "VpLd0XDedRQnpyrk";
var _3 = "ZNTg6_8t2SsKQewM";
var _4 = "uYnY4JJ69pQ_S91M";
export { _1 as "iconHolder", _2 as "pillBaseStyle", _3 as "pillSize__large", _4 as "pillSize__small" }
// extracted by css-extract-rspack-plugin
var _1 = "z4_iPqCAIbQzedZE";
var _2 = "VpLd0XDedRQnpyrk";
var _3 = "ZNTg6_8t2SsKQewM";
var _4 = "uYnY4JJ69pQ_S91M";
export { _1 as "iconHolder", _2 as "pillBaseStyle", _3 as "pillSize__large", _4 as "pillSize__small" }
